import { Stepper } from '@/components/Stepper';

import type { WizardStep } from './eventWizard.types';
import s from './EventWizardModal.module.scss';

interface WizardStepperProps {
  /**
   * Visible steps — an undated trip drops the AI plan step, so this is not always STEPS.
   * Only the label is read, so any wizard can pass its own steps.
   */
  steps: readonly Pick<WizardStep, 'label'>[];
  step: number;
  furthest: number;
  isSkippable: boolean;
  onGoToStep: (n: number) => void;
}

/**
 * The wizard's own row: the shared `Stepper` in its wide form, plus the line under it
 * naming the step you are on. Steps are 1-based here and 0-based in `Stepper`, so the
 * conversion lives in this one place rather than at every call.
 */
export function WizardStepper({
  steps,
  step,
  furthest,
  isSkippable,
  onGoToStep,
}: WizardStepperProps) {
  return (
    <div className={s.stepper}>
      <Stepper
        variant="bars"
        steps={steps.map((entry) => entry.label)}
        current={step - 1}
        furthest={furthest - 1}
        onStepClick={(index) => onGoToStep(index + 1)}
      />
      <div className={s.stepperMeta}>
        <span className={s.stepperLabel}>{steps[step - 1].label}</span>
        {isSkippable && <span className={s.optionalTag}>Optional</span>}
      </div>
    </div>
  );
}
